export default {
  checkIn: {
    aboutVisit: {
      am: 'a.m.',
      at: 'a las',
      choose: 'Elegir',
      hour: 'Hora',
      meridian: 'a.m./p.m.',
      min: 'Min.',
      pleaseEnterAValidTimeAndDate: 'Por favor, ingrese una hora y fecha válidas',
      pm: 'p.m.',
      timeCantBeFuture: 'La fecha/hora no puede estar en el futuro',
      today: 'Hoy',
      yesterday: 'Ayer'
    },
    checkIn: {
      info: 'He aquí cierta información...',
      browserOutdated: 'Su navegador no está actualizado. Por favor, actualice a un {0}navegador actual{1}.'
    },
    digitalReceipt: {
      currency: '€',
      description: 'Descripción',
      discount: 'Descuento',
      emailReceipt: 'Recibo del correo electrónico',
      mealReceipt: 'Recibo de la comida',
      price: 'Precio',
      save: 'Guardar',
      server: 'Servidor',
      serviceCharge: 'Cargo por servicio',
      tableNumber: 'Número de mesa',
      total: 'Total',
      yourEmail: 'Vuestro correo electrónico'
    },
    errors: {
      noSlug: 'No se ha aprobado ninguna etiqueta de la encuesta',
      badSlug: 'Se ha utilizado una etiqueta errónea de la encuesta'
    },
    guestTableNumberEntry: {
      mustBeANumber: 'El número de mesa debe ser un número',
      pleaseEnterTableNumber: 'Por favor, ingrese su número de mesa para que podamos encontrar vuestro pedido',
      tableNumber: 'Número de mesa',
      yourTableNumber: 'Vuestro número de mesa'
    },
    locationCheckIn: {
      checkIn: 'Registro',
      freeDesertOnYourNextVisit: 'Postre gratis en vuestra  próxima visita',
      pleaseTellUsAboutYourExperience: 'Cuéntenos vuestra  experiencia: ¡os llevará menos de un minuto!'
    },
    teamMemberReceiptPinEntry: {
      downloadingTransactionData: 'Descargando los datos de la transacción',
      enterPinNumber: 'Ingrese un número PIN',
      pinNumber: 'Número PIN'
    },
    teamMemberTableNumberEntry: {
      downloadingTransactionData: 'Descargando los datos de la transacción',
      mustBeANumber: 'El número de mesa debe ser un número',
      pleaseEnterTableNumber: 'Por favor, ingrese el número de mesa para descargar los datos de la transacción',
      tableNumber: 'Número de mesa',
      noNumber: 'Not Implemented.' // TODO: Translate (PWA)

    }
  }
};